import { onBeforeUnmount, onMounted, ref } from "vue";
import { useInitialViewportMode } from "../../../../../composables/useInitialViewportMode";

const PHONE_MAX_WIDTH = 767;
const DESKTOP_BREAKPOINT = 1280;

export function useViewportMode(onResize?: () => void) {
  const initialMode = useInitialViewportMode();

  const isPhoneViewport = ref(initialMode === "phone");
  const isTabletViewport = ref(initialMode === "tablet");
  const isDesktopViewport = ref(initialMode === "desktop");

  const syncViewport = () => {
    if (typeof window === "undefined") return;

    const width = window.innerWidth;
    const nextIsPhone = width <= PHONE_MAX_WIDTH;
    const nextIsDesktop = width >= DESKTOP_BREAKPOINT;

    isPhoneViewport.value = nextIsPhone;
    isDesktopViewport.value = nextIsDesktop;
    isTabletViewport.value = !nextIsPhone && !nextIsDesktop;
  };

  const handleResize = () => {
    syncViewport();
    onResize?.();
  };

  onMounted(() => {
    syncViewport();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
    }
  });

  onBeforeUnmount(() => {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", handleResize);
    }
  });

  return {
    isPhoneViewport,
    isTabletViewport,
    isDesktopViewport,
    syncViewport,
  };
}
